export default __webpack_public_path__ + "static/media/Brooke_Markevicius_AHV_In_Moms_We_Trust.5cb66d00.jpg";